var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',{attrs:{"vs-w":"12"}},[_c('vs-col',{staticClass:"min-ht-slider",attrs:{"vs-w":"12"}},[_c('ht-slider')],1),_c('vs-col',{staticClass:"mb-5"},[_c('div',[_c('b-container',[_vm._t("default")],2)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }